import React from 'react';
import { useTranslation } from 'react-i18next';
import { ChevronsLeft, ChevronsRight } from 'lucide-react';

interface SidebarCollapseToggleProps {
  readonly collapsed: boolean;
  readonly onToggle: () => void;
}

export const SidebarCollapseToggle: React.FC<SidebarCollapseToggleProps> = ({
  collapsed,
  onToggle,
}) => {
  const { t } = useTranslation();
  const label = collapsed ? t('app.v11.shell.pinOpen') : t('app.v11.shell.collapse');
  const Icon = collapsed ? ChevronsRight : ChevronsLeft;

  return (
    <button
      type="button"
      onClick={onToggle}
      aria-label={label}
      aria-expanded={!collapsed}
      title={collapsed ? label : undefined}
      data-testid="sidebar-collapse-toggle"
      className={`flex items-center rounded-[10px] text-[14px] font-medium leading-5 text-[rgba(11,11,11,0.5)] transition hover:bg-v11-surface-hover dark:text-white/50 ${
        collapsed ? 'h-10 w-10 justify-center' : 'gap-3 px-3 py-2.5'
      }`}
    >
      <Icon className="h-[18px] w-[18px]" strokeWidth={1.6} />
      {!collapsed && <span>{label}</span>}
    </button>
  );
};
